// URS-F402: formato monetario es-ES uniforme para toda la app.
// - Separador de miles con "." (forzado desde 4 digitos con useGrouping='always')
// - Separador decimal con ","
// - Dos decimales fijos + sufijo " €".

export function formatEUR(value) {
  if (value === null || value === undefined || value === '') return '0,00 €';
  const num = Number(value);
  if (Number.isNaN(num)) return `${value} €`;
  const formatted = new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: 'always',
  }).format(num);
  return `${formatted} €`;
}
